import { useRef } from 'react'

import { Alert, Box, Button } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import InputText from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import apiClient from 'modules/core/lib/mobx-rest/apiClient'

interface Props {
  accessId: string
  firstName: string
  onClose: () => void
}

const BecomeModal = ({ accessId, firstName, onClose }: Props) => {
  const { navigation } = useNavigation()
  const form = useRef(new Form({ reason: null }, { reason: 'string' })).current

  const reason = form.get('reason')

  const onSubmit = async () => {
    const { success } = await asyncAction(
      () => apiClient().post(`/accesses/${accessId}/start_become`, { reason: reason.value }),
      {
        successFlash: false,
      }
    )

    if (success) {
      window.location.href = navigation.dashboard.fullPath()
    }

    onClose()
  }

  return (
    <Modal
      title={i18n.t('authentication.become.modal.title')}
      description={i18n.t('authentication.become.modal.description', { name: firstName })}
      illustration="single-neutral-actions"
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={!reason.value} submit>
            {i18n.t('authentication.become.modal.submit', { name: firstName })}
          </Button>
        </>
      }
    >
      <Box paddingY="s24">
        <InputText label={i18n.t('authentication.become.modal.reason')} field={reason} />
      </Box>
      <Alert color="warning">
        {i18n.t('authentication.become.modal.alert', { name: firstName })}
      </Alert>
    </Modal>
  )
}

export default observer(BecomeModal)
